import { render, staticRenderFns } from "./SocialLinkItem.vue?vue&type=template&id=5eab8a8f&scoped=true"
import script from "./SocialLinkItem.vue?vue&type=script&lang=js"
export * from "./SocialLinkItem.vue?vue&type=script&lang=js"
import style0 from "./SocialLinkItem.vue?vue&type=style&index=0&id=5eab8a8f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eab8a8f",
  null
  
)

export default component.exports